import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-10 md:py-14 bg-[#0b0b0c]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="bg-white/95 rounded-md px-3 py-1.5">
            <img
              src="/assets/msr-logo.png"
              alt="MSR Residential Group"
              className="h-8 w-auto object-contain"
            />
          </div>
        </div>

        <div className="text-white/40 text-sm">
          &copy; {new Date().getFullYear()} MSR Residential Group. All rights reserved.
        </div>

        <div className="flex items-center gap-6 text-sm text-white/50">
          <a href="#top" className="hover:text-[#e4cfaf] transition-colors">Back to top</a>
          <a href="#faq" className="hover:text-[#e4cfaf] transition-colors">FAQ</a>
          <a href="#contact" className="hover:text-[#e4cfaf] transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  );
}
